import { css, SerializedStyles } from '@emotion/react';

/** TODO: 디자인시스템 버그 수정 시, 해당 기능 제거 후 대체 */
export function HOVER(
  template: TemplateStringsArray,
  ...args: Parameters<typeof css>[number][]
): SerializedStyles {
  return css`
    &.focus-visible:focus {
      ${css(template, ...args)}
    }
    @media(hover: hover) and (pointer: fine) {
      &:hover, &:active {
        ${css(template, ...args)}
      }
    }
  `;
}
